var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.37 135.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "32 80.4 71.89 80.4 91.84 45.86 71.89 11.31 32 11.31 12.06 45.86 32 80.4",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "75.71 87.02 90.99 60.56 99.48 45.86",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.41,
    y1: 45.86,
    x2: 28.18,
    y2: 87.02,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.71,
    y1: 4.69,
    x2: 28.18,
    y2: 4.69,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 103.4,
    y1: 45.86,
    x2: 96.05,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.33,
    y1: 45.86,
    x2: 0.98,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 77.79,
    y1: 1.51,
    x2: 74.12,
    y2: 7.87,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.26,
    y1: 83.84,
    x2: 26.59,
    y2: 90.2,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 77.79,
    y1: 90.2,
    x2: 74.12,
    y2: 83.84,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.26,
    y1: 7.87,
    x2: 26.59,
    y2: 1.51,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 77.92,
    y1: 45.86,
    x2: 74.96,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.5,
    y1: 45.86,
    x2: 73.61,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeDasharray: "0 0 0 0 .19 .14 .47 .19",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.52,
    y1: 45.86,
    x2: 70.57,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 25.97,
    y1: 45.86,
    x2: 28.93,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.39,
    y1: 45.86,
    x2: 30.28,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeDasharray: "0 0 0 0 .19 .14 .47 .19",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.37,
    y1: 45.86,
    x2: 33.32,
    y2: 45.86,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 38.96,
    y1: 68.35,
    x2: 40.44,
    y2: 65.79,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.67,
    y1: 65.39,
    x2: 41.11,
    y2: 64.62,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeDasharray: "0 0 0 0 .19 .14 .47 .19",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.16,
    y1: 64.54,
    x2: 42.64,
    y2: 61.98,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 64.93,
    y1: 23.36,
    x2: 63.45,
    y2: 25.92,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.22,
    y1: 26.32,
    x2: 62.78,
    y2: 27.09,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeDasharray: "0 0 0 0 .19 .14 .47 .19",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.73,
    y1: 27.17,
    x2: 61.26,
    y2: 29.73,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 38.96,
    y1: 23.36,
    x2: 40.44,
    y2: 25.92,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.67,
    y1: 26.32,
    x2: 41.11,
    y2: 27.09,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeDasharray: "0 0 0 0 .19 .14 .47 .19",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.16,
    y1: 27.17,
    x2: 42.64,
    y2: 29.73,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 64.93,
    y1: 68.35,
    x2: 63.45,
    y2: 65.79,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.22,
    y1: 65.39,
    x2: 62.78,
    y2: 64.62,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeDasharray: "0 0 0 0 .19 .14 .47 .19",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.73,
    y1: 64.54,
    x2: 61.26,
    y2: 61.98,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "71.21 26.59 67.14 19.54 59 19.54",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.26 52.91 82.33 45.86 78.26 38.81",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "59 72.17 67.14 72.17 71.21 65.12",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32.68 65.12 36.76 72.17 44.9 72.17",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "44.9 19.54 36.76 19.54 32.68 26.59",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.63 38.81 21.56 45.86 25.63 52.91",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "62.13 63.5 72.31 45.86 62.13 28.21",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.76 28.21 31.58 45.86 41.76 63.5",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.21,47.16h-1.73c-3.38,0-6.11,2.74-6.11,6.11v-3.85c0-2.58-1.53-4.79-3.73-5.79-.8-.37-1.69-.57-2.63-.57h-1.23c-3.51,0-6.36,2.85-6.36,6.36v-1.89c0-2.6-1.53-4.83-3.73-5.87-.83-.39-1.77-.61-2.75-.61h-.99c-3.58,0-6.48,2.9-6.48,6.48v-2.39c0-2.62-1.52-4.89-3.73-5.96-.87-.43-1.85-.67-2.89-.67h-.7c-3.66,0-6.62,2.97-6.62,6.62v20.45l-6.97-2.57-1.83,9.09c-1.18,5.87,.85,11.93,5.33,15.9,.86,.76,1.68,1.5,2.45,2.19,3.69,3.31,5.88,7.95,6.11,12.88,.01,.29,.02,.58,.02,.87v10.76h45.57v-15.1c0-1.64,.59-3.22,1.67-4.45,1.11-1.28,1.98-2.73,2.56-4.3,.58-1.56,.89-3.23,.89-4.92V53.28c0-3.38-2.74-6.11-6.11-6.11Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.52,75.22c1.77,.33,3.4-1.03,3.4-2.83v-27.25c0-3.19,2.26-5.85,5.26-6.48-.43-.09-.87-.14-1.33-.14h-.7c-3.66,0-6.62,2.97-6.62,6.62v30.08s0,0,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.01,103.06c-.23-4.93-2.42-9.57-6.11-12.88-.77-.69-1.59-1.42-2.45-2.19-4.48-3.97-6.51-10.03-5.33-15.9l1.6-7.92-3.16-1.17-1.83,9.09c-1.18,5.87,.85,11.93,5.33,15.9,.86,.76,1.68,1.5,2.45,2.19,3.69,3.31,5.88,7.95,6.11,12.88,.01,.29,.02,.58,.02,.87v10.76h3.4v-10.76c0-.29,0-.58-.02-.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.21,47.16h-1.73c-.63,0-1.24,.1-1.81,.27,2.49,.77,4.3,3.09,4.3,5.84v32.64c0,1.7-.31,3.36-.89,4.92-.58,1.56-1.45,3.02-2.56,4.3-1.07,1.24-1.67,2.82-1.67,4.45v15.1h5.35v-15.1c0-1.64,.59-3.22,1.67-4.45,1.11-1.28,1.98-2.73,2.56-4.3,.58-1.56,.89-3.23,.89-4.92V53.27c0-3.38-2.74-6.11-6.11-6.11Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.47,
    y1: 47.54,
    x2: 55.47,
    y2: 54.07,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.42,
    y1: 49.41,
    x2: 69.42,
    y2: 55.94,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.38,
    y1: 52.68,
    x2: 83.38,
    y2: 59.21,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.52,
    y1: 65.59,
    x2: 41.52,
    y2: 75.22,
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.21,47.16h-1.73c-3.38,0-6.11,2.74-6.11,6.11v-3.85c0-2.58-1.53-4.79-3.73-5.79-.8-.37-1.69-.57-2.63-.57h-1.23c-3.51,0-6.36,2.85-6.36,6.36v-1.89c0-2.6-1.53-4.83-3.73-5.87-.83-.39-1.77-.61-2.75-.61h-.99c-3.58,0-6.48,2.9-6.48,6.48v-2.39c0-2.62-1.52-4.89-3.73-5.96-.87-.43-1.85-.67-2.89-.67h-.7c-3.66,0-6.62,2.97-6.62,6.62v20.45l-6.97-2.57-1.83,9.09c-1.18,5.87,.85,11.93,5.33,15.9,.86,.76,1.68,1.5,2.45,2.19,3.69,3.31,5.88,7.95,6.11,12.88,.01,.29,.02,.58,.02,.87v10.76h45.57v-15.1c0-1.64,.59-3.22,1.67-4.45,1.11-1.28,1.98-2.73,2.56-4.3,.58-1.56,.89-3.23,.89-4.92V53.28c0-3.38-2.74-6.11-6.11-6.11Z",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,113.59h52.49v20.24H43.17v-20.24Z",
    style: {
      fill: "#5e9fe1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,113.59h52.49v7H43.17v-7Z",
    style: {
      fill: "#4194d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,113.59h52.49v20.24H43.17v-20.24Z",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.3,
    cy: 123.71,
    r: 4.04,
    style: {
      fill: "#dff3fa",
      stroke: "#1779da",
      strokeMiterlimit: 10,
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.3,
    cy: 123.71,
    r: 2.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.59,
    y1: 130.87,
    x2: 93.85,
    y2: 130.87,
    style: {
      fill: "none",
      stroke: "#4194d8",
      strokeDasharray: "0 0 3.94 3.94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.59,
    y1: 117.09,
    x2: 93.85,
    y2: 117.09,
    style: {
      fill: "none",
      stroke: "#5e9fe1",
      strokeDasharray: "0 0 3.94 3.94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,47.16c-4.39,0-8.35,1.92-11.05,4.99-.55,.59-1.03,1.25-1.46,1.92h-5.5v15.76h5.5c.55,.89,1.2,1.71,1.94,2.45,2.66,2.75,6.42,4.46,10.56,4.46,.72,0,1.42-.04,2.11-.17,7.16-1.01,12.68-7.18,12.68-14.62,0-8.16-6.63-14.79-14.79-14.79Zm3.95,21.7h-7.9l-2.73-4.8-1.2-2.11,3.93-6.91h7.9l3.93,6.91-3.93,6.91Z",
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.32,
    y: 54.07,
    width: 4.27,
    height: 15.76,
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.52,54.07h-8.22c-2.62-4.16-7.25-6.91-12.51-6.91-6.44,0-11.92,4.12-13.95,9.87H23.6l2.28,4.92-2.28,4.92H6.85c2.03,5.75,7.5,9.87,13.95,9.87h.28c5.15-.11,9.65-2.81,12.23-6.91h8.22v-15.76Z",
    style: {
      fill: "#91c0db"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4,47.31c-.67-.09-1.36-.15-2.06-.15-6.44,0-11.92,4.12-13.95,9.87h4.07c1.81-5.14,6.38-8.97,11.93-9.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.32 66.87 28.61 61.95 26.32 57.03 23.15 57.03 25.43 61.95 23.15 66.87 26.32 66.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.46,66.87H6.39c2.03,5.75,7.5,9.87,13.95,9.87h.28c.6-.01,1.2-.06,1.78-.15-5.55-.76-10.12-4.58-11.93-9.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.79,58.43h4.73v7.16h-4.73c-1.98,0-3.58-1.6-3.58-3.58h0c0-1.98,1.6-3.58,3.58-3.58Z",
    style: {
      fill: "#7ab2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,47.16c-4.39,0-8.35,1.92-11.05,4.99-.55,.59-1.03,1.25-1.46,1.92h-5.5v15.76h5.5c.55,.89,1.2,1.71,1.94,2.45,2.66,2.75,6.42,4.46,10.56,4.46,.72,0,1.42-.04,2.11-.17,7.16-1.01,12.68-7.18,12.68-14.62,0-8.16-6.63-14.79-14.79-14.79Zm3.95,21.7h-7.9l-2.73-4.8-1.2-2.11,3.93-6.91h7.9l3.93,6.91-3.93,6.91Z",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.52,54.07h-8.22c-2.62-4.16-7.25-6.91-12.51-6.91-6.44,0-11.92,4.12-13.95,9.87H23.6l2.28,4.92-2.28,4.92H6.85c2.03,5.75,7.5,9.87,13.95,9.87h.28c5.15-.11,9.65-2.81,12.23-6.91h8.22v-15.76Z",
    style: {
      fill: "none",
      stroke: "#1779da",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.94px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5.67,
    y1: 106.02,
    x2: 10.4,
    y2: 106.02,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.67,
    y1: 128.08,
    x2: 32.45,
    y2: 128.08,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5.67 128.08 10.4 128.08 10.4 94.99 5.67 94.99",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.14,
    cy: 128.08,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.14,
    cy: 106.02,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.67,
    y1: 117.05,
    x2: 10.4,
    y2: 117.05,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.14,
    cy: 117.05,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.14,
    cy: 94.99,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.45,
    cy: 128.08,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 129.99,
    y1: 105.53,
    x2: 125.26,
    y2: 105.53,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.99,
    y1: 127.59,
    x2: 104.78,
    y2: 127.59,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "129.99 127.59 125.26 127.59 125.26 94.5 129.99 94.5",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.52,
    cy: 127.59,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.52,
    cy: 105.53,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.99,
    y1: 116.56,
    x2: 125.26,
    y2: 116.56,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.52,
    cy: 116.56,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.52,
    cy: 94.5,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.78,
    cy: 127.59,
    r: 2.63,
    style: {
      fill: "#f3fcff",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.31,101.76v2.52c0,.68,.73,1.1,1.32,.76l2.06-1.2c.27-.16,.43-.45,.43-.76v-1.32c0-.48-.39-.88-.88-.88h-2.06c-.48,0-.88,.39-.88,.88Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.02,101.76v1.32c0,.31,.16,.59,.43,.75l2.06,1.23c.58,.35,1.33-.07,1.33-.75v-2.55c0-.48-.39-.88-.88-.88h-2.06c-.48,0-.88,.39-.88,.88Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8,100.41l.27,7.13,11.21,2.62v-1.98c0-.81-.44-1.57-1.15-1.96l-10.33-5.8Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,116.31l5.58,1.24v-1.34c0-.34-.12-.66-.34-.91l-3.75-4.25-1.48,5.26Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,116.21v1.34s5.59-1.21,5.59-1.21l-1.49-5.3-3.75,4.25c-.22,.25-.34,.58-.34,.91Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.87,108.19v1.98s11.21-2.63,11.21-2.63l.27-7.13-10.33,5.81c-.71,.4-1.15,1.15-1.15,1.96Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.01,94.4c-.22-.56-.76-.92-1.36-.92h-.21c-.6,0-1.13,.36-1.36,.92l-.06,.15c-.66,1.64-.99,3.21-.99,4.66v11.21c0,1.49,.31,2.95,1,4.73l.62,1.41h.82s.97,0,.97,0l.61-1.39v-.02c.56-1.42,1.07-2.97,1.07-4.73v-11.23c0-1.78-.53-3.36-1.11-4.8Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,118.26c-.39,0-.7-.31-.7-.7v-5.71c0-.39,.31-.7,.7-.7s.7,.31,.7,.7v5.71c0,.39-.31,.7-.7,.7Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.07 98.2 110.57 97.77 109.15 98.2 109.15 96.84 110.61 96.41 112.07 96.84 112.07 98.2",
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.32,101.74h-1.49v-1.49h-1.49v1.49h-1.49v1.49h1.49v1.49h-2.99v-2.99h-2.99v-5.97h5.97v2.99h1.49v-1.49h1.49v1.49h1.49v4.48h-1.49v-1.49Zm-7.47-4.48v2.99h2.99v-2.99h-2.99Zm7.47-1.49h1.49v1.49h-1.49v-1.49Zm-2.99,5.97h1.49v1.49h-1.49v-1.49Zm-5.97,1.49h1.49v1.49h-1.49v-1.49Zm1.49,1.49h1.49v1.49h-1.49v-1.49Zm7.47,0h1.49v1.49h-1.49v-1.49Zm-2.99,0h1.49v1.49h-1.49v-1.49Zm-3.73-6.72h1.49v1.49h-1.49v-1.49Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 30.56,
    y1: 97.31,
    x2: 35.82,
    y2: 97.31,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.56,
    y1: 100.99,
    x2: 35.82,
    y2: 100.99,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.56,
    y1: 104.67,
    x2: 32.66,
    y2: 104.67,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.32,114.86h-1.49v-1.49h-1.49v1.49h-1.49v1.49h1.49v1.49h-2.99v-2.99h-2.99v-5.97h5.97v2.99h1.49v-1.49h1.49v1.49h1.49v4.48h-1.49v-1.49Zm-7.47-4.48v2.99h2.99v-2.99h-2.99Zm7.47-1.49h1.49v1.49h-1.49v-1.49Zm-2.99,5.97h1.49v1.49h-1.49v-1.49Zm-5.97,1.49h1.49v1.49h-1.49v-1.49Zm1.49,1.49h1.49v1.49h-1.49v-1.49Zm7.47,0h1.49v1.49h-1.49v-1.49Zm-2.99,0h1.49v1.49h-1.49v-1.49Zm-3.73-6.72h1.49v1.49h-1.49v-1.49Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 30.56,
    y1: 110.43,
    x2: 35.82,
    y2: 110.43,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.56,
    y1: 114.11,
    x2: 35.82,
    y2: 114.11,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.56,
    y1: 117.79,
    x2: 32.66,
    y2: 117.79,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,10.44h11.06c1.89,0,3.41,1.53,3.41,3.41h0c0,1.89-1.53,3.41-3.41,3.41h-2.39c-2.54,0-4.19,2.67-3.05,4.94l3.94,7.88c.58,1.16,1.76,1.89,3.05,1.89h6.29",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.01 80.48 125.37 82.16 128.72 80.48 127.05 83.84 128.72 87.19 125.37 85.51 122.01 87.19 123.69 83.84 122.01 80.48",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.94 80.48 116.29 82.16 119.65 80.48 117.97 83.84 119.65 87.19 116.29 85.51 112.94 87.19 114.62 83.84 112.94 80.48",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.86 80.48 107.22 82.16 110.57 80.48 108.9 83.84 110.57 87.19 107.22 85.51 103.86 87.19 105.54 83.84 103.86 80.48",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "18.49 29.11 4.09 29.11 1.93 8.7 20.64 8.7 18.49 29.11",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.98,
    y: 3.2,
    width: 20.6,
    height: 5.5,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.86,
    y: 0.98,
    width: 16.85,
    height: 2.22,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.49 29.11 4.09 29.11 1.93 8.7 20.64 8.7 18.49 29.11",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.98,
    y: 3.2,
    width: 20.6,
    height: 5.5,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.86,
    y: 0.98,
    width: 16.85,
    height: 2.22,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.29,
    cy: 18.05,
    r: 4.88,
    style: {
      fill: "#b2dbf7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.48,12.87c0-.61-.5-1.11-1.11-1.11s-1.11,.5-1.11,1.11,.5,1.11,1.11,1.11",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.83,
    y1: 13.98,
    x2: 98.37,
    y2: 13.98,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.48,
    y1: 12.87,
    x2: 99.48,
    y2: 15.08,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,14.37h-.91c-.68-3.34-2.61-6.15-5.24-8,.23-1.22,.38-3.01-.3-4.4-.86-1.76-3.9-1.2-7.36,2.04h-2.38c-.07,0-.14,0-.21,0-8.59,.12-15.45,7.17-15.33,15.76,.07,3.31,2.22,6.1,5.18,7.13v4.32h5.18v-3.89h6.48v3.89h5.18v-3.89h.32c3.45,0,6.58-2.03,7.98-5.18h1.41c1.07,0,1.94-.87,1.94-1.94v-3.89c0-1.07-.87-1.94-1.94-1.94Z",
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,14.37h-.91c-.68-3.34-2.61-6.15-5.24-8,.23-1.22,.38-3.01-.3-4.4-.86-1.76-3.9-1.2-7.36,2.04h-2.38c-.07,0-.14,0-.21,0-8.59,.12-15.45,7.17-15.33,15.76,.07,3.31,2.22,6.1,5.18,7.13v4.32h5.18v-3.89h6.48v3.89h5.18v-3.89h.32c3.45,0,6.58-2.03,7.98-5.18h1.41c1.07,0,1.94-.87,1.94-1.94v-3.89c0-1.07-.87-1.94-1.94-1.94Z",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.06,
    y1: 27.33,
    x2: 108.96,
    y2: 27.33,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.72,
    y1: 27.33,
    x2: 120.62,
    y2: 27.33,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.26,
    cy: 10.81,
    r: 0.88,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.9,
    cy: 18.28,
    rx: 0.5,
    ry: 1.87,
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15,10.53c2.86-2.53,6.18-3.89,9.27-3.84",
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.97px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 100.97,
    cy: 38.81,
    r: 5.07,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,37.1c.39,.05,.72,.21,.89,.44,.03,.04,.05,.1,.05,.16,0,.14-.12,.26-.27,.26-.07,0-.14-.04-.21-.11-.15-.15-.41-.26-.69-.26-.41,0-.56,.19-.56,.39,0,.65,1.8,.34,1.8,1.58,0,.54-.34,.9-1,.96v.28c0,.13-.1,.23-.23,.23s-.23-.1-.23-.23v-.28c-.48-.06-.85-.32-1.02-.59-.02-.04-.04-.09-.04-.14,0-.15,.12-.27,.26-.27,.11,0,.17,.06,.22,.11,.21,.21,.47,.37,.81,.37,.45,0,.66-.15,.66-.45,0-.72-1.8-.39-1.8-1.58,0-.44,.28-.82,.91-.89v-.28c0-.13,.1-.23,.23-.23s.23,.1,.23,.23v.29Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.97,
    cy: 38.81,
    r: 3.85,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 100.97,
    y1: 33.74,
    x2: 100.97,
    y2: 34.11,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.97,
    y1: 43.5,
    x2: 100.97,
    y2: 43.87,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.04,
    y1: 38.81,
    x2: 105.66,
    y2: 38.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.28,
    y1: 38.81,
    x2: 95.9,
    y2: 38.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 104.55,
    y1: 35.22,
    x2: 104.29,
    y2: 35.49,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.65,
    y1: 42.12,
    x2: 97.38,
    y2: 42.39,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.55,
    y1: 42.39,
    x2: 104.29,
    y2: 42.12,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.65,
    y1: 35.49,
    x2: 97.38,
    y2: 35.22,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 114.03,
    cy: 38.81,
    r: 5.07,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,37.1c.39,.05,.72,.21,.89,.44,.03,.04,.05,.1,.05,.16,0,.14-.12,.26-.27,.26-.07,0-.14-.04-.21-.11-.15-.15-.41-.26-.69-.26-.41,0-.56,.19-.56,.39,0,.65,1.8,.34,1.8,1.58,0,.54-.34,.9-1,.96v.28c0,.13-.1,.23-.23,.23s-.23-.1-.23-.23v-.28c-.48-.06-.85-.32-1.02-.59-.02-.04-.04-.09-.04-.14,0-.15,.12-.27,.26-.27,.11,0,.17,.06,.22,.11,.21,.21,.47,.37,.81,.37,.45,0,.66-.15,.66-.45,0-.72-1.8-.39-1.8-1.58,0-.44,.28-.82,.91-.89v-.28c0-.13,.1-.23,.23-.23s.23,.1,.23,.23v.29Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.03,
    cy: 38.81,
    r: 3.85,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 114.03,
    y1: 33.74,
    x2: 114.03,
    y2: 34.11,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.03,
    y1: 43.5,
    x2: 114.03,
    y2: 43.87,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.1,
    y1: 38.81,
    x2: 118.72,
    y2: 38.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.34,
    y1: 38.81,
    x2: 108.96,
    y2: 38.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 117.61,
    y1: 35.22,
    x2: 117.34,
    y2: 35.49,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.71,
    y1: 42.12,
    x2: 110.44,
    y2: 42.39,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.61,
    y1: 42.39,
    x2: 117.34,
    y2: 42.12,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.71,
    y1: 35.49,
    x2: 110.44,
    y2: 35.22,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 127.09,
    cy: 38.81,
    r: 5.07,
    style: {
      fill: "#dff3fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.34,37.1c.39,.05,.72,.21,.89,.44,.03,.04,.05,.1,.05,.16,0,.14-.12,.26-.27,.26-.07,0-.14-.04-.21-.11-.15-.15-.41-.26-.69-.26-.41,0-.56,.19-.56,.39,0,.65,1.8,.34,1.8,1.58,0,.54-.34,.9-1,.96v.28c0,.13-.1,.23-.23,.23s-.23-.1-.23-.23v-.28c-.48-.06-.85-.32-1.02-.59-.02-.04-.04-.09-.04-.14,0-.15,.12-.27,.26-.27,.11,0,.17,.06,.22,.11,.21,.21,.47,.37,.81,.37,.45,0,.66-.15,.66-.45,0-.72-1.8-.39-1.8-1.58,0-.44,.28-.82,.91-.89v-.28c0-.13,.1-.23,.23-.23s.23,.1,.23,.23v.29Z",
    style: {
      fill: "#b2dbf7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.09,
    cy: 38.81,
    r: 3.85,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 127.09,
    y1: 33.74,
    x2: 127.09,
    y2: 34.11,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.09,
    y1: 43.5,
    x2: 127.09,
    y2: 43.87,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.16,
    y1: 38.81,
    x2: 131.78,
    y2: 38.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.4,
    y1: 38.81,
    x2: 122.02,
    y2: 38.81,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 130.67,
    y1: 35.22,
    x2: 130.4,
    y2: 35.49,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.77,
    y1: 42.12,
    x2: 123.5,
    y2: 42.39,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.67,
    y1: 42.39,
    x2: 130.4,
    y2: 42.12,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.77,
    y1: 35.49,
    x2: 123.5,
    y2: 35.22,
    style: {
      fill: "none",
      stroke: "#b2dbf7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".98px"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.318876f73b4a099ba7a7cec88e46cda1.svg";
export { ForwardRef as ReactComponent };